import type {EntityBase} from 'types';
import type {AvailabilityStatus} from 'api/types';
import type {Media} from 'services/media/types';
import type {ProductOwner} from 'services/metadata/types';
import type {Schemas} from 'api/dto.generated';

export type TaskType = 'new' | 'pre' | 'control' | 'change' | 'mottak' | 'ml';
export type TaskTypeAll = TaskType | 'all';
export const TaskTypes: Readonly<TaskType[]> = [
  'new',
  'pre',
  'control',
  'change',
  'mottak',
  'ml',
] as const;

export const DeprecatedTaskTypes: Readonly<TaskType[]> = [
  'ml',
  'mottak',
] as const;

export type TaskV2 = EntityBase<number> & {
  type: TaskType;
  status?: Schemas.TaskV2Dto['status'];
  metadata: {
    manifestationId: Required<Schemas.TaskV2Dto>['metadata']['manifestationId'];
    workId: Required<Schemas.TaskV2Dto>['metadata']['workId'];
    isbn?: Required<Schemas.TaskV2Dto>['metadata']['isbn']; // string;
    mainTitle?: Required<Schemas.TaskV2Dto>['metadata']['title']; // string;
    mainAgent?: string; // Just a string, because we recieve a Verified Agent without id.
    productForm?: Required<Schemas.TaskV2Dto>['metadata']['productForm']; // string;
    contentReceivedDate?: Schemas.MetadataDto['contentReceivedDate'];
    publisherSalesDate?: Schemas.MetadataDto['publisherSalesDate'];
    inSaleDate?: Schemas.MetadataDto['inSaleDate'];
    availabilityStatus?: Schemas.MetadataDto['availabilityStatus'];
    media?: Media[];
    productOwner?: ProductOwner;
    registered?: Schemas.MetadataDto['registered'];
  };
};

//----- OverviewTask -------------------------------------------------------------------------------
export type OverviewTask = {
  /**
   * Id of user who has locked the task (work), if any
   */
  lockedBy?: string;
  id: number;
  taskTypes: TaskType[];
  manifestationId?: string;
  workId?: string;
  isbn?: string;
  ean?: string;
  mainTitle?: string;
  mainAgent?: string;
  productForm?: string;
  availabilityStatus?: AvailabilityStatus;
  // Should be undefined, not null, when missing
  inSaleDate?: string | undefined;
  publisherSalesDate?: string | undefined;
  contentReceivedDate?: string | undefined;
  publishedYear?: number;
  media?: Media[];
  searchableTaskString: string;
  productOwner?: ProductOwner;
  productOwnerName?: ProductOwner['name'];
  productOwnerCode?: ProductOwner['code'];
  registered?: number;
};
export type TaskStatus = Required<Schemas.TaskDto>['status'];
